function clearBodyScrollLock() {
  if (document.body.classList.contains('slack-chat-open')) {
    return;
  }

  document.body.classList.remove('modal-open');
  document.body.style.removeProperty('overflow');
  document.body.style.removeProperty('padding-right');
}

function removeOrphanedBackdrops() {
  if (document.querySelector('.modal')) {
    return;
  }

  document.querySelectorAll('.modal-backdrop').forEach((el) => {
    el.remove();
  });
}

/** Remove stuck modal backdrops / body lock when no modal is open. */
export function cleanupModalBody() {
  if (document.querySelectorAll('.modal.show').length > 0) {
    return;
  }

  clearBodyScrollLock();
  removeOrphanedBackdrops();
}

/** Clear body lock and orphaned backdrops after modal close animations finish. */
export function forceModalCleanup() {
  if (document.querySelectorAll('.modal.show').length > 0) {
    scheduleModalCleanup();
    return;
  }

  clearBodyScrollLock();
  removeOrphanedBackdrops();
}

/** Run cleanup after Bootstrap modal exit animations finish. */
export function scheduleModalCleanup() {
  cleanupModalBody();
  window.setTimeout(cleanupModalBody, 150);
  window.setTimeout(cleanupModalBody, 350);
  window.setTimeout(forceModalCleanup, 600);
  window.setTimeout(forceModalCleanup, 1000);
}
